// extracted by mini-css-extract-plugin
var _1 = "TableCellEditor-module__container--Jqjsc";
var _2 = "TableCellEditor-module__editor--fWl01";
export { _1 as "container", _2 as "editor" }
